export const MEDIA_SECTIONS = [
  { id: "hero", fr: "Hero (diaporama page d'accueil)", en: "Hero (homepage slideshow)" },
  { id: "realisations", fr: "Galerie « Réalisations »", en: "'Our work' gallery" },
  { id: "cabinet", fr: "Le Cabinet", en: "The Firm" },
  { id: "expertises", fr: "Expertises", en: "Expertise" },
  { id: "methode", fr: "Méthodologie", en: "Methodology" },
  { id: "clients", fr: "Clients", en: "Clients" },
  { id: "valeurs", fr: "Valeurs", en: "Values" },
];
